export default "__VITE_ASSET__31278068__"